// import { lazy, Suspense, useEffect, useState } from "react";
// import { BrowserRouter } from "react-router-dom";
// import Swal from "sweetalert2";
// import { ReactSession } from "react-client-session";
// import { gapi } from "gapi-script";
// import axios from "axios";
// import "./App.css";
// import Preloader from "./themes/sampanganimation/Pages/Preloader";
// import global from "./config";
// import PageNotFound from "./themes/sampanganimation/Pagenotfound";

// function App() {
//   const [ThemeComponents, setThemeComponents] = useState(null);
//   ReactSession.setStoreType("localStorage");

//   // Fungsi kontrol loader
//   // const hideLoader = () => {
//   //   const loader = document.getElementById("preloader");
//   //   if (loader) loader.style.display = "none";
//   // };

//   useEffect(() => {
//     const initGoogleAPI = () => {
//       gapi.load("client:auth2", () => {
//         gapi.client.init({
//           clientId: "203471354608-gognnrj3fe89bi5hf5451rplevpuil2s.apps.googleusercontent.com",
//           scope: "",
//         });
//       });
//     };

//     const fetchTheme = async () => {
//       try {
//         // const { data } = await axios.get(`${global.config.host}/themes`);
//         const { data } = await axios.get(`${global.config.host}/themes-data`);
//         if (data.status !== "success") throw new Error("Backend error");

//         global.config.theme = data.theme;
//         global.config.title = data.title;
//         // global.config.backend = `${global.config.host}/${data.theme}`;
//         global.config.backend = `${global.config.host}/themes/${data.theme}`;
//         global.config.apiBappedalitbang = `${global.config.apiBappedalitbang}/${data.theme}`;

//         // Update favicon
//         const icon = document.querySelector('link[rel="icon"]');
//         if (icon) {
//           icon.href = `${global.config.backend}/api/getimage/L2Fzc2V0cy9pbWcvbG9nby5wbmc=`;
//         }

//         // Dynamic import components
//         const HeaderLazy = lazy(() => import(`./themes/${data.theme}/Header.js`));
//         const ContentLazy = lazy(() => import(`./themes/${data.theme}/Content.js`));
//         const FooterLazy = lazy(() => import(`./themes/${data.theme}/Footer.js`));

//         setThemeComponents(
//           <BrowserRouter basename={`/${global.config.subdomain}`}>
//             <HeaderLazy />
//             <ContentLazy />
//             <FooterLazy />
//           </BrowserRouter>
//         );
//       } catch (err) {
//         console.error(err);
//         Swal.fire({
//           title: "Error Connect",
//           text: "Error connect to services",
//           icon: "warning",
//         });
//       }
//     };

//     initGoogleAPI();
//     fetchTheme();
//   }, []);

//   // Hilangkan loader ketika ThemeComponents sudah siap
//   // useEffect(() => {
//   //   if (ThemeComponents) hideLoader();
//   // }, [ThemeComponents]);

//   return (
//     ThemeComponents ?
//       <Suspense fallback={<PageNotFound />}>{ThemeComponents}</Suspense>
//       :  (<Preloader src="/assets/upload/images/template_image/logo-sampang.png" />)
//   );
// }

// export default App;


// App.js
import { lazy, Suspense, useEffect, useState, useCallback } from "react";
import { BrowserRouter } from "react-router-dom";
import Swal from "sweetalert2";
import { ReactSession } from "react-client-session";
import { gapi } from "gapi-script";
import axios from "axios";
import "./App.css";
import Preloader from "./themes/sampanganimation/Pages/Preloader";
import global from "./config";
import PageNotFound from "./themes/sampanganimation/Pagenotfound";
import ErrorBoundary from "./ErrorBoundary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import "./themes/sampanganimation/assets/error-screen.css";
import Logo from "./themes/sampanganimation/assets/img/logo-sampang.png";

function App() {
  const [ThemeComponents, setThemeComponents] = useState(null);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    ReactSession.setStoreType("localStorage");
  }, []);

  const initGoogleAPI = useCallback(() => {
    try {
      gapi.load("client:auth2", () => {
        gapi.client
          .init({
            clientId:
              "203471354608-gognnrj3fe89bi5hf5451rplevpuil2s.apps.googleusercontent.com",
            scope: "",
          })
          .catch((err) => console.error("Google API init gagal:", err));
      });
    } catch (err) {
      console.error("gapi.load gagal:", err);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchTheme = async () => {
      try {
        const { data } = await axios.get(`${global.config.host}/themes`, {
          timeout: 10000,
        });

        if (data.status !== "success") throw new Error("Backend error: status bukan success");
        if (!data.theme) throw new Error("Theme tidak ditemukan di response");

        global.config.theme = data.theme;
        global.config.title = data.title;
        global.config.backend = `${global.config.host}/${data.theme}`;
        global.config.apiBappedalitbang = `${global.config.apiBappedalitbang}/${data.theme}`;

        const icon = document.querySelector('link[rel="icon"]');
        if (icon) {
          icon.href = `${global.config.backend}/api/getimage/L2Fzc2V0cy9pbWcvbG9nby5wbmc=`;
        }

        const HeaderLazy = lazy(() =>
          import(`./themes/${data.theme}/Header.js`).catch(() => {
            throw new Error(`Gagal load Header theme "${data.theme}"`);
          })
        );
        const ContentLazy = lazy(() =>
          import(`./themes/${data.theme}/Content.js`).catch(() => {
            throw new Error(`Gagal load Content theme "${data.theme}"`);
          })
        );
        const FooterLazy = lazy(() =>
          import(`./themes/${data.theme}/Footer.js`).catch(() => {
            throw new Error(`Gagal load Footer theme "${data.theme}"`);
          })
        );

        if (!isMounted) return;

        setThemeComponents(
          <BrowserRouter basename={`/${global.config.subdomain}`}>
            <HeaderLazy />
            <ContentLazy />
            <FooterLazy />
          </BrowserRouter>
        );
        setError(null);
      } catch (err) {
        console.error("fetchTheme error:", err);
        if (!isMounted) return;

        setError(err.message || "Gagal konek ke server");

        Swal.fire({
          title: "Error Connect",
          text: err.message || "Error connect to services",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Coba Lagi",
          cancelButtonText: "Tutup",
        }).then((result) => {
          if (result.isConfirmed && isMounted) {
            setRetryCount((c) => c + 1);
          }
        });
      }
    };

    initGoogleAPI();
    fetchTheme();

    return () => {
      isMounted = false;
    };
  }, [retryCount, initGoogleAPI]);

  if (error && !ThemeComponents) {
    return (
      <div className="error-screen">
        <div className="error-card">
          <div className="error-icon-wrapper">
            <FontAwesomeIcon icon={faTriangleExclamation} className="error-icon" />
          </div>
          <h2 className="error-title">Gagal Memuat Halaman</h2>
          <p className="error-message">
            {error || "Terjadi kesalahan yang tidak diketahui. Silakan coba lagi."}
          </p>
          <button className="error-retry-btn" onClick={() => setRetryCount((c) => c + 1)}>
            <FontAwesomeIcon icon={faRotateRight} className="me-2" />
            Coba Lagi
          </button>
        </div>
      </div>
    );
  }

  return ThemeComponents ? (
    <ErrorBoundary fallback={<PageNotFound />}>
      <Suspense fallback={<Preloader src={Logo} />}>{ThemeComponents}</Suspense>
      {/* <Preloader src={Logo} /> */}
    </ErrorBoundary>
  ) : (
    <Preloader src={Logo} />
  );
}

export default App;
